var COLORS = [
    '#5663ED',
    '#17B0D7',
    '#B53D97',
    '#F5BD00',
    '#FF6F47',
    '#20999D',
    '#C44861',
    '#A1CD25',
    '#C2C2C2'
];
var INDICATOR_COLORS = [
    null,
    'danger',
    'warning',
    'success',
    'accent',
    'brand',
    'tertiary',
    'interactive',
    'neutral'
];
var INDICATOR_ICONS = [
    null,
    'check',
    'x',
    'help',
    'solid'
];
var INDICATOR_POSITIONS = [
    'top-start',
    'top-end',
    'bottom-start',
    'bottom-end'
];
export { COLORS, INDICATOR_COLORS, INDICATOR_ICONS, INDICATOR_POSITIONS };
